import React, { useState, useCallback } from "react";

export const useScrollPosition = () => {
  const [position, setPosition] = useState<number>(0);

  const onScroll = useCallback<React.UIEventHandler<HTMLDivElement>>(event => {
    const { currentTarget } = event;
    setPosition(currentTarget.scrollTop);
  }, []);

  return [position, onScroll] as const;
};
